<template>

  <div class="form-group">
    <div style="display: flex; justify-content: center;">
      <el-button v-if="form.holder.bank_holder_id==0||!form.holder.bank_holder_id" @click="openchooseholder">選擇並綁定已有的戶主信息</el-button>
      <el-button v-if="form.holder.bank_holder_id>0" @click="unassociation" type="danger">取消已綁定的戶主</el-button>
      <el-dialog @closed="closechooseholder" title="導入戶主名稱" :visible.sync="chooseholder" width="95%" :append-to-body="true">
        <component @closeholder="closeholder" :is="chooseholder_component"></component>
      </el-dialog>
    </div>
    <div class="form-group-content">
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="代號" prop="holder.code">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.code"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="戶主姓名" prop="holder.name">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.name">
              <el-button slot="append" @click="form.holder.name=sify(form.holder.name)">繁轉簡</el-button>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="身份證卡號" prop="holder.card">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.card"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="戶主電話" prop="holder.phone">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.phone"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="負責人" prop="holder.holderman">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.holderman">
              <el-button slot="append" @click="form.holder.holderman=sify(form.holder.holderman)">繁轉簡</el-button>
            </el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="負責人電話" prop="holder.holder_phone">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.holder_phone"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="代理人" prop="holder.agentman">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.agentman">
							<el-button slot="append" @click="form.holder.agentman=sify(form.holder.agentman)">繁轉簡</el-button>
						</el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="代理人電話" prop="holder.agent_phone">
            <el-input :disabled="form.holder.bank_holder_id>0" v-model="form.holder.agent_phone"></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="銀行卡">
            <el-radio :disabled="form.holder.bank_holder_id>0" v-model="form.holder.cardtype" label="0">公司</el-radio>
            <el-radio :disabled="form.holder.bank_holder_id>0" v-model="form.holder.cardtype" label="1">代理</el-radio>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="銀行USB">
            <el-radio :disabled="form.holder.bank_holder_id>0" v-model="form.holder.usb" label="0">公司</el-radio>
            <el-radio :disabled="form.holder.bank_holder_id>0" v-model="form.holder.usb" label="1">代理</el-radio>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="租/買">
            <el-radio :disabled="form.holder.bank_holder_id>0" v-model="form.holder.buytype" label="0">出租</el-radio>
            <el-radio :disabled="form.holder.bank_holder_id>0" v-model="form.holder.buytype" label="1">購買</el-radio>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="戶口到埗日期" prop="holder.endtime">
            <el-date-picker :disabled="form.holder.bank_holder_id>0" type="date" placeholder="選擇日期" v-model="form.holder.endtime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="戶口提示日期" prop="holder.tipstime">
            <el-date-picker :disabled="form.holder.bank_holder_id>0" type="date" placeholder="選擇日期" v-model="form.holder.tipstime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="戶口起租日期" prop="holder.startrent_time">
            <el-date-picker :disabled="form.holder.bank_holder_id>0" type="date" placeholder="選擇日期" v-model="form.holder.startrent_time" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <el-form-item label="戶口交租日期" prop="holder.endrent_time">
            <el-date-picker :disabled="form.holder.bank_holder_id>0" type="date" placeholder="選擇日期" v-model="form.holder.endrent_time" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import chooseholder from './ChooseHolder.vue';
export default {
  components: {

    chooseholder
  },
  props: ['form'],
  data () {
    return {
      chooseholder: false,
      chooseholder_component: '',
    };
  },
  methods: {
    closeholder (holder) {
      this.form.holder.bank_holder_id = holder.id;// 關聯ID
      this.chooseholder = false;
      this.chooseholder_component = '';
      this.form.holder.code = holder.code;
      this.form.holder.name = holder.name;
      this.form.holder.card = holder.card;
      this.form.holder.phone = holder.phone;
      this.form.holder.holderman = holder.holderman;
      this.form.holder.holder_phone = holder.holder_phone;
      this.form.holder.agentman = holder.agentman;
      this.form.holder.agent_phone = holder.agent_phone;
      this.form.holder.cardtype = holder.cardtype.toString();
      this.form.holder.usb = holder.usb.toString();
      this.form.holder.buytype = holder.buytype.toString();
      this.form.holder.endtime = holder.endtime;
      this.form.holder.tipstime = holder.tipstime;
      this.form.holder.startrent_time = holder.startrent_time;
      this.form.holder.endrent_time = holder.endrent_time;
    },
    unassociation(){
      this.form.holder.bank_holder_id = 0;// 關聯ID
      this.form.holder.code = '';
      this.form.holder.name = '';
      this.form.holder.card = '';
      this.form.holder.phone = '';
      this.form.holder.holderman = '';
      this.form.holder.holder_phone = '';
      this.form.holder.agentman = '';
      this.form.holder.agent_phone = '';
      this.form.holder.cardtype = '0';
      this.form.holder.usb = '0';
      this.form.holder.buytype = '0';
      this.form.holder.endtime = '';
      this.form.holder.tipstime = '';
      this.form.holder.startrent_time = '';
      this.form.holder.endrent_time = '';
    },
    closechooseholder () {
      this.chooseholder = false;
      this.chooseholder_component = '';
    },
    openchooseholder () {
      this.chooseholder = true;
      this.chooseholder_component = chooseholder;
    },


  },
  created () {

  }

};
</script>

<style>
</style>
